module.exports = "<div class=\"panel panel-default\">\n    <div class=\"panel-heading\" style=\"cursor: pointer;\">\n        <ng-content select=\"collapse-form-child-header\"></ng-content>\n    </div>\n    <div [id]=\"'collapse'+id\" class=\"panel-collapse collapse\" [ngClass]=\"openByDefault?'in':''\">\n        <div class=\"panel-body\">\n            <ng-content select=\".collapse-body\"></ng-content>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/collapse/child/collapse.form.child.template.html
// module id = 955
// module chunks = 0